import { makeStyles } from '@mui/styles';
export default makeStyles(() => ({
  applyRow: {
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start',
    marginBottom: '12px'
  },
  codeField: {
    flex: 1
  },
  targetField: {
    minWidth: '220px'
  },
  appliedList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  appliedRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    padding: '10px 12px',
    borderRadius: '4px',
    backgroundColor: 'rgba(0, 0, 0, 0.03)'
  },
  appliedText: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0
  },
  code: {
    fontWeight: 700,
    letterSpacing: '0.02em'
  },
  target: {
    fontStyle: 'italic'
  }
}));